// src/layouts/MainLayout.js
// Layout principal avec Navbar/BottomNav - NE PAS MODIFIER

import React from 'react';
import { Outlet } from 'react-router-dom';
import BottomNav from '../components/layout/BottomNav';
import NotificationCenter from '../notifications/NotificationCenter';

const MainLayout = () => {
  const styles = {
    appContainer: {
      maxWidth: '480px',
      width: '100%',
      margin: '0 auto',
      backgroundColor: '#0A0E1A',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
    },
    content: {
      flex: 1,
      paddingBottom: '64px', // Espace pour BottomNav
      overflowY: 'auto',
    },
  };

  return (
    <div style={styles.appContainer}>
      <div style={styles.content}>
        <Outlet />
      </div>
      <BottomNav />
      <NotificationCenter />
    </div>
  );
};

export default MainLayout;